import { makeStyles } from '@alpha/ui-lib/ui/external';

const useStyles = makeStyles(() => ({
  root: (props: any) => ({
    marginBottom: '32px',
    position: 'relative',
    '& td': {
      padding: '10px 0 !important',
    },
    '& td.MuiTableCell-root': {
      height: props.shortRows && '32px !important',
      padding: props.shortRows && '0px !important',
    },
    overflow: 'auto',
  }),
}), { name: 'Table' });

export default useStyles;
